'use strict';

class BandejapagoModalController {
  constructor($uibModalInstance, data, DataService, $log, $state, Storage, Modal, Message) {
    'ngInject';
    this.items = data;
    this.$uibModalInstance = $uibModalInstance;
    this.DataService = DataService;
    this.$log = $log;
    this.$state = $state;
    this.Storage = Storage;
    this.Modal = Modal;
    this.Message = Message;   

  }

  $onInit() {    
    this.selected = this.items;    
    this.conf = {
      prod: {
        sec_nombre: "PRODUCTOS",
        sec_visible: true,
        // 1
        nombre_producto: {
          visible: true,
          requerido: true,
          label: "Producto",
        },
        precio_referencial: {
          label: "Precio Referencial (Bs.)",
          visible: true,
          requerido: true,
        },
        unidad_medida: {
          visible: true,
          requerido: false,
          label: "Descripción unidad de medida",
        },
        fid_par_unidad_medida: {
          visible: true,
          requerido: true,
          label: "Unidad de medida",
        },
      }
    };
    this.DataService.get(`certificaciones/${this.selected.certificacion.id_certificacion }`).then(response=>{
      this.form = angular.copy(response.certificacion.formulario);
      this.esRefrigerio = false;
      this.$log.log('esRefrigerio en llenado de formulario de PRODUCTOS');
      if(this.form.id_formulario===10){
        this.esRefrigerio = true;
      } 
      this.$log.log(this.esRefrigerio);
    })
  }

  ok () {
    this.Modal.confirm('Una vez enviados los productos productos, ya no podrá modificarlos hasta la aprobación de un técnico. ¿Desea continuar?', () => {
      this.DataService.put('certificaciones/' + this.selected.certificacion.id_certificacion + '/enviarEdicionProducto')
      .then((respuesta) => {
        if (respuesta) {
          this.Message.success('Su registro se encuentra Pendiente de Aprobación.');
          this.$uibModalInstance.close(this.selected);
          this.$state.reload();
        }
      });
    });
  }

  cancel() {
    this.$uibModalInstance.dismiss('cancel');
    this.$state.reload();
  }
}

export default BandejapagoModalController;



// WEBPACK FOOTER //
// ./src/app/components/probolivia/empresario/bandeja/bandeja.producto.modal.controller.js